export default __webpack_public_path__ + "static/media/GP.49693a5f.svg";